import type { TelegramWebAppUser } from './verifyInitData';

export interface SessionResponse {
  ok: boolean;
  unverified?: boolean;
  session: string | null;
  user: TelegramWebAppUser | null;
  error?: string;
  hint?: string;
}

export async function createSession(initData: string, apiBase = ''): Promise<SessionResponse> {
  const url = `${apiBase.replace(/\/$/, '')}/api/session`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ initData }),
  });
  const body = (await response.json()) as SessionResponse;
  if (!response.ok && !body.ok) {
    return body;
  }
  return body;
}
